import script from "./toggle-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./toggle-content.vue?vue&type=script&setup=true&lang=ts"

import "./toggle-content.vue?vue&type=style&index=0&id=dcfcc2e0&lang=scss"

const __exports__ = script;

export default __exports__